
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Fish } from "lucide-react";

export const SpeciesLimits = () => {
  return (
    <RegulationItem 
      value="limits" 
      icon={Fish}
      title="Species & Limits"
    >
      <div className="space-y-4">
        <div>
          <h4 className="font-semibold text-tribal-secondary mb-2">Mountain View & Sheep Creek Reservoirs</h4>
          <ul className="list-disc pl-5 space-y-2 text-tribal-neutral">
            <li>
              <p className="font-medium">Rainbow Trout:</p>
              <ul className="list-disc pl-5">
                <li>Daily Limit: 5 per adult (max 10 in possession).</li>
                <li>No size restrictions.</li>
              </ul>
            </li>
            <li>
              <p className="font-medium">Yellow Perch/Bass:</p>
              <ul className="list-disc pl-5">
                <li>No size/bag limits (keep all caught fish).</li>
              </ul>
            </li>
            <li>
              <p className="font-medium">Fishing Poles:</p>
              <ul className="list-disc pl-5">
                <li>1 pole per angler (2 poles allowed with additional permit).</li>
                <li>Hooks: Single or treble with artificial lure, fly, or natural bait (Live bait prohibited, except earthworms).</li>
              </ul>
            </li>
            <li>
              <p className="font-medium">Ice Fishing (Mountain View & Sheep Creek):</p>
              <ul className="list-disc pl-5">
                <li>Up to 5 poles or tip-ups in 5 holes per angler (single permit covers this; 2-pole permit does not allow more).</li>
              </ul>
            </li>
          </ul>
        </div>
        
        <div>
          <h4 className="font-semibold text-tribal-secondary mb-2">Lake Billy Shaw</h4>
          <ul className="list-disc pl-5 space-y-1 text-tribal-neutral">
            <li>Fly fishing only (one fly rod, artificial fly, single barbless hook/dropper).</li>
            <li>Electric-powered boats only.</li>
            <li>Rainbow Trout: 1 fish daily (16" - 29" only). Release smaller or larger unharmed.</li>
          </ul>
        </div>
        
        <div>
          <h4 className="font-semibold text-tribal-secondary mb-2">East Fork Owyhee River</h4>
          <ul className="list-disc pl-5 text-tribal-neutral">
            <li>Fly fishing & catch-and-release only (all fish must be safely released).</li>
          </ul>
        </div>
      </div>
    </RegulationItem>
  );
};
